import getWeworkCorpInfo from './getWeworkCorpInfo';
import getSyncConfig from './getSyncConfig';
import getInnerAppAccessToken from './getInnerAppAccessToken';

function getParmasError() {
    return getWeworkCorpInfo({ useCache: true }).then(res => {
        const { corpSecret, corpId } = res;
        if (corpSecret) {
            return getInnerAppAccessToken(corpId);
        }

        return { hasError: false };
    });
}

export default function getContactError() {
    return getParmasError().then(res => {
        const { hasError, errMsg } = res;

        if (hasError) {
            return {
                hasError,
                errMsg,
                errType: 'params'
            };
        }

        return getSyncConfig({ useCache: true });
    });
}
